export default function getResource(label) {
    const resources = {
        freeReturns: 'Free Returns',
        subHeader: 'Return Products for FREE',
        canadaText: 'New or gently used products can be returned in person to any Sephora Canada store or by mail with our pre-paid return shipping label. No return shipping or handling fees apply. Buy Online, Pick Up In Store and Instacart orders can only be returned in store. Gift cards and intimate devices are not eligible for returns.',
        gotIt: 'Got It',
        learnMore: 'Learn More',
        assuranceSubHeader: 'Get 30 Days FREE and Easy Returns Online and In Store',
        assuranceBody: 'If you are not completely satisfied with a Sephora purchase or gift for any reason, Sephora welcomes you to return new or gently used products for a full refund to your original method of payment if returned within 30 days of purchase.',
        seeReturnsExchanges: 'See Returns & Exchanges for more info'
    };

    return resources[label];
}
